/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
module.exports = {
    /**
     * Called with detailed debugging information
     * @param {string | object} message
     * @param {object} context
     */
    debug: (message, context) => console.log(message),

    /**
     *
     * @param {string} message
     * @param {object} context
     */
    info: (message, context) => console.info(message),

    /**
     * Called for logging expected error conditions
     * @param {string} warning
     * @param {object} context
     */
    warn: (warning, context) => console.warn(warning),

    /**
     * Called for unhandled errors.
     * @param {Error} error Javascript Error object. Note: this object is not serializable by default
     * @param {string} error.message
     * @param {string} error.stack
     * @param {object} context
     */
    error: (error, context) => console.error(error),
};
